import React, { useMemo } from "react";
import { MessageBanner } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { MERGE_IMPACT_KIND_LABEL_IDS, MERGE_IMPACT_TABLE_LABEL_IDS, summarizeMergeImpact, } from "../../../utils/mergeImpact";
export var MergeResultCallout = function (_a) {
    var completion = _a.completion, onDismiss = _a.onDismiss;
    var formatMessage = useIntl().formatMessage;
    var details = useMemo(function () {
        return summarizeMergeImpact(completion.plan)
            .map(function (row) {
            var table = row.known
                ? formatMessage({ id: MERGE_IMPACT_TABLE_LABEL_IDS[row.table] })
                : formatMessage({ id: "ui-br-legaldeposits.titleMerge.impact.table.unknown" }, { table: row.table });
            var entries = row.entries
                .map(function (entry) {
                return formatMessage({ id: MERGE_IMPACT_KIND_LABEL_IDS[entry.kind] }, { count: entry.count });
            })
                .join(", ");
            return "".concat(table, ": ").concat(entries);
        })
            .join(" · ");
    }, [completion.plan, formatMessage]);
    return (React.createElement(MessageBanner, { type: "success", dismissible: true, onExited: onDismiss, "data-test-id": "merge-result-callout" },
        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.result.heading", values: {
                count: completion.absorbedCount,
                name: completion.survivorName,
            } }),
        details && " ".concat(details)));
};
